export * from './IncidentProperties';
